import React from 'react';
import Loader from '@amzn/meridian/loader';
import Row from '@amzn/meridian/row';
import Column from '@amzn/meridian/column';

const LoadingComponent: React.FC<{ isLoading: boolean }> = ({
  isLoading,
}) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Column heights='100%' alignmentVertical='center'>
      <Row alignmentHorizontal='center'>
        <Loader size='medium'/>
      </Row>
    </Column>
  );
};

export default LoadingComponent;